import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 42 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, dark = false }) => (
  <Reveal className="mb-12 max-w-3xl">
    <p className="overline-label mb-4">{overline}</p>
    <h2
      className={`font-serif text-3xl tracking-tight sm:text-4xl lg:text-5xl ${
        dark ? "text-white" : "text-brand-ink"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p
        className={`mt-5 text-base leading-relaxed ${
          dark ? "text-white/70" : "text-brand-muted"
        }`}
      >
        {sub}
      </p>
    )}
  </Reveal>
);
